export default __webpack_public_path__ + "static/media/Group 11770.ed4b5b7f.svg";